import React, { useEffect, useRef } from "react";
import Select, { components } from "react-select";
import { Modal } from "react-bootstrap";
import { FaMinusCircle, FaRegDotCircle } from "react-icons/fa";
import styles from "./purchase.module.scss";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { FaPlus } from "react-icons/fa";
import InputText from "../../common/Input/InputText";
import InputDate from "../../common/Input/InputDate";
import AddUpdateItem from "./addUpdateItem";
import AddUpdateSupplier from "../../components/supplier/addUpdateSupplier";
import { getGstinTypeSlice } from "../../../store/slices/gstinTypeSlice";
import {
  addSupplierSlice,
  resetAddSupplierMessage,
  getSupplierSlice,
} from "../../../store/slices/supplierSlice";
import { getMedicineTypeSlice } from "../../../store/slices/medicineTypeSlice";
import AsyncSelect from "react-select/async";

const AddUpdatePurchase = ({
  showModal,
  setShowModal,
  purchaseFormData,
  handleChange,
  handleAddUpdate,
  handleSelectChange,
  supplier,
  setPurchaseFormData,
  modalAction,
}) => {
  const [showItemModal, setShowItemModal] = useState(false);
  // const [items, setItems] = useState([]);
  const [showSupplierModal, setShowSupplierModal] = useState(false);
  const [supplierFormData, setSupplierFormData] = useState({
    status: "Active",
  });
  const [editIndex, setEditIndex] = useState(null);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (modalAction && purchaseFormData?.items?.length >= 0) {
  //     setItems(purchaseFormData.items);
  //   }
  // }, [modalAction, purchaseFormData]);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);

  const clinicId =clinicInfo?.[0]?.clinicId || null;

  useEffect(() => {
    dispatch(getGstinTypeSlice({ status: ["Active"], token }));
  }, [dispatch, token, showSupplierModal]);

  useEffect(() => {
    dispatch(getMedicineTypeSlice({ token }));
  }, [dispatch, token, showItemModal]);

  const { gstinTypes } = useSelector((state) => state.gstinType);
  const { medicineTypes } = useSelector((state) => state.medicineType);

  const [inputError, setInputError] = useState({
    name: false,
  });

 
  const handleShowItemModal = () => {
    setShowModal(false);
    setShowItemModal(true);
  };

  const handleAddItem = (item) => {
    setPurchaseFormData((prev) => ({
      ...prev,
      items: [...prev.items, item], // or [...prev.items, item]
    }));
    setShowItemModal(false);
    setShowModal(true);
  };
  const subtotal = (purchaseFormData?.items || []).reduce(
    (sum, item) => sum + Number(item?.totalAmount || 0),
    0,
  );

  const handleRemoveItem = (index) => {
    setPurchaseFormData((prev) => {
      const newItems = [...prev.items];
      newItems.splice(index, 1);
      return { ...prev, items: newItems };
    });
  };

  const handleSupplierDataChange = (e, field = null) => {
    if (field === "gstinType") {
      setSupplierFormData((prev) => ({
        ...prev,
        gstinType: e?.value || "",
        gstinTypeName: e?.label || "",
      }));
    } else if (e?.target) {
      const { name, value } = e.target;
      setSupplierFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (e?.editor) {
      const value = e.editor.getData();
      setSupplierFormData((prev) => ({
        ...prev,
        address: value,
      }));
    }
  };

  const handleAddOrUpdateSupplier = async (e) => {
    e.preventDefault();
    try {
      const response = await dispatch(
        addSupplierSlice({
          ...supplierFormData,
          clinicId,
          token,
        }),
      );
      const newSupplier = response?.payload?.result?.list;
      if (newSupplier?._id) {
        setShowSupplierModal(false);
        setShowModal(true);
        setSupplierFormData({});
        const updatedSuppliers = [...supplier, newSupplier];

        setPurchaseFormData((prev) => ({
          ...prev,
          supplier: newSupplier?._id,
          supplierName: newSupplier?.name,
        }));

        setTimeout(() => {
          dispatch(resetAddSupplierMessage());
        }, 500);
      }
    } catch (error) {
      console.error("Failed to add supplier:", error);
    }
  };
  const handleEditItem = (index) => {
    setEditIndex(index);
  };

  const handleItemChange = (index, field, value) => {
    setPurchaseFormData((prev) => {
      const updatedItems = [...prev.items];
      const item = { ...updatedItems[index], [field]: value };

      // Numeric conversion
      item.quantity = Number(item.quantity) || 0;
      item.purchasePrice = Number(item.purchasePrice) || 0;
      item.discount = Number(item.discount) || 0;
      item.taxRate = Number(item.taxRate) || 0;

      // Recalc
      const gross = item.quantity * item.purchasePrice;
      const discountAmt = (gross * item.discount) / 100;
      item.taxbleAmount = gross - discountAmt;
      if (item.isInclusiveTax === "No") {
        const taxAmt = (item.taxbleAmount * item.taxRate) / 100;
        item.totalAmount = item.taxbleAmount + taxAmt;
      } else {
        item.totalAmount = item.taxbleAmount;
      }

      updatedItems[index] = item;
      return { ...prev, items: updatedItems };
    });
  };

  const loadSupplierOptions = async (inputValue) => {
    const response = await dispatch(
      getSupplierSlice({
        clinicId,
        token,
        name: inputValue,
        // limit: 10,
        // currentPage: 1,
        status:"Active",
      }),
    );

    const data = response?.payload?.result?.list || [];

    return data.map((item) => ({
      value: item._id,
      label: item.name,
    }));
  };

  const CustomMenu = (props) => {
    return (
      <components.Menu {...props}>
        {props.children}

        <div
          className="border-top p-2 text-primary d-flex align-items-center"
          style={{ cursor: "pointer", fontWeight: 500 }}
          onMouseDown={(e) => {
            e.preventDefault();
            setShowModal(false);
            setShowSupplierModal(true);
          }}
        >
          <FaPlus className="me-2" />
          Add New Supplier
        </div>
      </components.Menu>
    );
  };
  return (
    <>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {modalAction === "edit" ? "EDIT PURCHASE" : "ADD PURCHASE"}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowModal(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleAddUpdate(purchaseFormData?.items);
            }}
          >
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <label className="col-form-label">Supplier</label>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={loadSupplierOptions}
                    defaultOptions
                    value={
                      purchaseFormData?.supplier
                        ? {
                            value: purchaseFormData?.supplier,
                            label: purchaseFormData?.supplierName,
                          }
                        : null
                    }
                    onChange={(selectedOption) =>
                      handleSelectChange(selectedOption, "supplier")
                    }
                    components={{ Menu: CustomMenu }}
                    placeholder="Select Supplier"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputText
                    name="invoiceId"
                    value={purchaseFormData?.invoiceId}
                    onChange={handleChange}
                    label="Invoice Id"
                    placeholder={"Enter Invoice Id"}
                  />
                </div>
              </div>
              <div className="col-xl-4">
                <div className="form-group position-relative">
                  <InputDate
                    name="invoiceDate"
                    value={purchaseFormData?.invoiceDate}
                    onChange={(e) => handleChange(e, "invoiceDate")}
                    placeholder="Invoice Date"
                  />
                </div>
              </div>

              <div className="styles.addButtonWrapper">
                <button
                  type="button"
                  className="btn btn-primary btn-rounded me-4"
                  onClick={() => handleShowItemModal()}
                >
                  + Add Item
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-primary">
                {modalAction === "edit" ? "Update" : "Save"}
              </button>
            </div>
            <div className="mt-3">
              {purchaseFormData?.items?.length === 0 ? (
                <p className="text-center">No items added.</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>Price (Rs)</th>
                        <th>Discount</th>
                        <th>Amount</th>
                        <th>Tax(%)</th>
                        <th>Total Amount</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {purchaseFormData?.items?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item?.name}</td>
                          <td>
                            {editIndex === index ? (
                              <input
                                type="number"
                                value={item?.quantity}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "quantity",
                                    e?.target?.value,
                                  )
                                }
                                className={styles.editableInput}
                              />
                            ) : (
                              item?.quantity
                            )}
                          </td>
                          <td>
                            {editIndex === index ? (
                              <input
                                type="number"
                                value={item?.purchasePrice}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "purchasePrice",
                                    e?.target?.value,
                                  )
                                }
                                className={styles.editableInput}
                              />
                            ) : (
                              item?.purchasePrice
                            )}
                          </td>
                          <td>
                            {editIndex === index ? (
                              <input
                                type="number"
                                value={item?.discount}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "discount",
                                    e?.target?.value,
                                  )
                                }
                                className={styles.editableInput}
                              />
                            ) : (
                              item?.discount
                            )}
                          </td>
                          <td>{item?.taxbleAmount}</td>
                          <td>{item?.taxRate}</td>
                          <td>{item?.totalAmount}</td>
                          <td>
                            {editIndex === index ? (
                              <button
                                type="button"
                                className="btn btn-sm btn-success me-2"
                                onClick={() => setEditIndex(null)}
                              >
                                Save
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-sm btn-warning me-2"
                                onClick={() => handleEditItem(index)}
                              >
                                <FaRegDotCircle />
                              </button>
                            )}
                            {modalAction !== "edit" && (
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => handleRemoveItem(index)}
                              >
                                <FaMinusCircle />
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="text-end mt-3 me-2">
                    <strong>Subtotal: ₹{subtotal?.toFixed(2)}</strong>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </Modal>
      <AddUpdateItem
        showItemModal={showItemModal}
        setShowItemModal={setShowItemModal}
        handleAddItem={handleAddItem}
        medicineTypes={medicineTypes}
        // isMode={isMode}
      />
      <AddUpdateSupplier
        showModal={showSupplierModal}
        setModalVisible={setShowSupplierModal}
        gstinTypes={gstinTypes}
        inputError={inputError}
        setInputError={setInputError}
        handleChange={handleSupplierDataChange}
        modalAction="create"
        formData={supplierFormData}
        handleAddOrUpdateSupplier={handleAddOrUpdateSupplier}
      />
    </>
  );
};

export default AddUpdatePurchase;
